<template>
  <div class="setting-page w-full">
    <vx-card class="mb-8">
      <div class="flex flex-wrap">
        <div class="w-full flex flex-wrap">
          <p class="mb-5 titles w-2/3">Personal Information</p>
          <div class="sm:block w-1/3">
            <a
              id="settings-personal-personal-edit-button"
              class="block float-right font-medium static edit-section-btn"
              v-if="!changePersonalData && $can()"
              @click="changePersonalData=true"
              href="#/"
            >Edit</a>
            <div class="clearfix hidden sm:block" v-if="changePersonalData">
              <vs-button id="settings-personal-personal-save-button" class="personal-save-button float-right btn-save" @click="updateProfile()">Save</vs-button>
              <vs-button
                id="settings-personal-personal-cancel-button"
                class="float-right mr-5 btn-cancel"
                type="border"
                color="dark"
                @click="changePersonalData=false; refreshPeresonalInfo()"
              >Cancel</vs-button>

            </div>
          </div>
        </div>
        <div class="w-full flex flex-wrap">
          <div class="vx-row w-full clearfix mb-6 pt-4">
            <div class="vx-col">
              <input
                id="settings-personal-personal-upload-photo-input"
                type="file"
                style="display: none;"
                name="avatar"
                ref="fileInput"
                accept="image/jpg, image/png, image/jpeg"
                @change="setAvatar"
              />
              <img size="130px" class="avatar cursor-pointer" :src="avatarUrl" v-on:click="openFileUploader()" />
              <span
              class="text-danger text-sm block pt-2"
              v-show="errors.has('avatar')"
            >{{ errors.first('avatar') }}</span>
            </div>
            <div class="vx-col mt-8">
              <div class="fullname pb-2">{{`${firstName} ${lastName}`}}</div>
              <p class="small-txt">Max photo size 1 MB</p>
            </div>
          </div>
          <div class="w-full mb-2 sm:w-1/2 sm:pr-3">
            <label class="labels">First Name</label>
            <vs-input
              id="settings-personal-personal-first-name-input"
              name="first name"
              class="w-full pt-2 pb-4"
              maxlength="15"
              v-validate="'required|min:2|max:15'"
              :disabled="!changePersonalData"
              v-model="firstName"
            />
            <span
              class="text-danger text-sm block pt-1"
              v-show="errors.has('first name')"
            >{{ errors.first('first name') }}</span>
          </div>
          <div class="w-full mb-2 sm:w-1/2 sm:pl-3">
            <label class="labels">Last Name (optional)</label>
            <vs-input
              id="settings-personal-personal-last-name-input"
              class="w-full pt-2 pb-4"
              name="last name"
              placeholder="Last Name"
              maxlength="25"
              :disabled="!changePersonalData"
              v-model="lastName"
            />
            <span
              class="text-danger text-sm block pt-2"
              v-show="errors.has('last name')"
            >{{ errors.first('last name') }}</span>
          </div>
          <div class="w-full mb-2 sm:w-1/2 sm:pr-3">
            <label class="labels">Email</label>
            <vs-input id="settings-personal-personal-email-input" disabled class="w-full pt-2 pb-4" v-model="email" />
          </div>
          <div class="w-full mb-2 sm:w-1/2 sm:pl-3">
            <label class="labels">Phone Number</label>
            <vue-phone-number-input
              id="settings-personal-personal-phone-input"
              :default-country-code="phone.countryCode"
              :disabled="!changePersonalData"
              v-model="phone.formattedNumber"
              class="w-full pt-2 pb-4"
              size="sm"
              valid-color="#999999"
              v-on:update="phoneUpdated"
            />
            <span
              class="text-danger text-sm block pt-1"
              v-show="errors.has('phone')"
            >{{ errors.first('phone') }}</span>
          </div>
          <p v-if="changePersonalDataError">
            <span class="text-danger text-sm">{{ changePersonalDataError }}</span>
          </p>
        </div>
        <div class="w-full sm:hidden" :class="{ 'mt-5': changePersonalData}">
          <div class="clearfix" v-if="changePersonalData">
            <vs-button id="settings-personal-personal-mobile-save-button" class="personal-save-button w-full mb-5 btn-save" @click="updateProfile()">Save</vs-button>
            <vs-button
              id="settings-personal-personal-mobile-cancel-button"
              class="w-full btn-cancel"
              type="border"
              color="dark"
              @click="changePersonalData=false; refreshPeresonalInfo()"
            >Cancel</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="clearfix">
      <div class="flex flex-wrap">
        <div class="w-full flex flex-wrap pt-4">
          <p class="mb-5 titles w-1/2">Password</p>
          <div class="sm:block w-1/2">
            <a
              id="settings-personal-password-edit-button"
              class="block float-right font-medium static edit-section-btn"
              v-if="!changePassword && $can()"
              @click="changePassword=true"
              href="#/"
            >Edit</a>
            <div class="clearfix hidden sm:block" v-if="changePassword">
              <vs-button id="settings-personal-password-save-button" class="personal-save-button float-right btn-save" @click="updatePassword()">Save</vs-button>
              <vs-button
                id="settings-personal-password-cancel-button"
                class="float-right mr-5 btn-cancel"
                type="border"
                color="dark"
                @click="changePassword=false; resetPasswordFields()"
              >Cancel</vs-button>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-wrap">
          <div class="w-full sm:w-1/2 sm:pr-3 mb-5">
            <label class="labels">
              Current Password
            </label>
            <div class="relative">
              <em
                  class="show-password-icon speakol icon icon-no-border"
                  @click="showCurrentPasswordStatus = !showCurrentPasswordStatus"
                  :class="{ 'speakol-eye': showCurrentPasswordStatus, 'speakol-hide': !showCurrentPasswordStatus}"
              ></em>
              <vs-input
                id="settings-personal-password-current-password-input"
                v-validate="'required'"
                data-vv-validate-on="input|keyup|blur"
                name="current password"
                :type="showCurrentPasswordStatus ? 'text' : 'password'"
                :disabled="!changePassword"
                placeholder="Current Password"
                class="password-field w-full pt-2 pb-4 current-password"
                v-model="currentPassword"
              />
              <span
                class="text-danger text-sm block pt-1"
                v-show="errors.has('current password')"
              >{{ errors.first('current password') }}</span>
            </div>
          </div>
          <div class="w-full flex flex-wrap">
            <div class="w-full sm:w-1/2 sm:pr-3 mb-5">
              <label class="labels">
                New Password
              </label>
              <div class="relative">
                <em
                  class="show-password-icon speakol icon icon-no-border"
                  @click="showNewAndConfirmPasswordStatus = !showNewAndConfirmPasswordStatus"
                  :class="{ 'speakol-eye': showNewAndConfirmPasswordStatus, 'speakol-hide': !showNewAndConfirmPasswordStatus}"
                ></em>

                <vs-input
                  id="settings-personal-password-new-password-input"
                  ref="password"
                  :type="showNewAndConfirmPasswordStatus ? 'text' : 'password'"
                  data-vv-validate-on="input|keyup|blur"
                  v-validate="'required|min:8|hasNumbers|minCharacters|hasLowerAndUpercases|specialCharacter'"
                  name="new password"
                  placeholder="New Password"
                  :disabled="!changePassword"
                  v-model="newPassword"
                  @change="validatePasswordConfirmation"
                  class="password-field w-full pt-2 pb-4 new-password"
                />
                <span class="text-danger text-sm block pt-1">{{ errors.first('new password') }}</span>
              </div>
            </div>
            <div class="w-full sm:w-1/2 sm:pl-3 mb-5">
              <label class="labels">
                Confirm New Password
              </label>
              <div class="relative">
                <vs-input
                  id="settings-personal-password-confirm-password-input"
                  :type="showNewAndConfirmPasswordStatus ? 'text' : 'password'"
                  v-validate="'required'"
                  @change="validatePasswordConfirmation"
                  :disabled="!changePassword"
                  placeholder="Confirm New Password"
                  v-model="confirmPassword"
                  name="confirm password"
                  class="w-full password-field pt-2 pb-4 confirm-password"
                />
                <span
                  class="text-danger text-sm block pt-1"
                  v-show="errors.has('confirm password')"
                >{{ errors.first('confirm password') }}</span>
              </div>
            </div>
          </div>
          <p v-if="chanePasswordError">
            <span class="text-danger text-sm">{{ chanePasswordError }}</span>
          </p>
        </div>
        <div class="w-full sm:hidden" :class="{ 'mt-5': changePassword}">
          <div class="clearfix" v-if="changePassword">
            <vs-button id="settings-personal-password-mobile-save-button" class="personal-save-button w-full mb-5 btn-save" @click="updatePassword()">Save</vs-button>
            <vs-button
              id="settings-personal-password-mobile-cancel-button"
              class="w-full btn-cancel"
              type="border"
              color="dark"
              @click="changePassword=false; resetPasswordFields()"
            >Cancel</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

    <div class="success-personal-data">
      <vs-popup class="personal-success-pop-up" title :active.sync="chanePersonalDataPopup">
        <img src="@/assets/images/pages/settings/loading.svg" class="success-pop-up-img center" />
        <p class="pop-up-text" style="text-align: center;">Your profile has been successfully updated.</p>
        <vs-button id="settings-personal-personal-success-popup-button" size="medium" v-on:click="exitPersonalDataPopup" class="success-button shadow-none center">Ok</vs-button>
      </vs-popup>
    </div>

    <vs-popup title :active.sync="chanePasswordPopup">
      <img src="@/assets/images/pages/settings/loading.svg" class="center" />
      <p style="text-align: center;">Password has been successfully updated.</p>
      <br />
      <br />
      <vs-button id="settings-personal-password-success-popup-button" size="medium" v-on:click="chanePasswordPopup=false" class="center">Ok</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import { objectToFormData } from '@/helpers/objectToFormData.js'
import {get} from 'lodash'

export default {
  data () {
    const {
      firstName,
      lastName,
      email,
      phone
    } = this.getUserInfo()

    return {
      showCurrentPasswordStatus: false,
      showNewAndConfirmPasswordStatus: false,
      firstName,
      lastName: lastName || '',
      email,
      phone,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      avatar: '',
      changePersonalData: false,
      chanePersonalDataPopup: false,
      changePassword: false,
      chanePasswordError: '',
      chanePasswordPopup: false,
      changePersonalDataError: '',
      avatarTempSource: ''
    }
  },
  mounted () {
    this.$parent.setupTabsBar()
  },
  computed: {
    avatarUrl () {
      const user = this.$store.getters['authentication/user']

      return this.avatarTempSource || get(user, 'media[0].url', null) || require('@/assets/images/pages/settings/profile_logo.svg')
    }
  },
  methods: {
    validatePasswordConfirmation () {
      if (this.confirmPassword !== this.newPassword) {
        this.$validator.errors.add({
          field: 'confirm password',
          msg: 'The two passwords do not match.'
        })
        return
      }
      this.$validator.errors.remove('confirm password')
    },
    getUserInfo () {
      const { name, phone, email, country } = this.$store.getters[
        'authentication/user'
      ]

      const names = name.split(' ')

      const firstName = names[0]

      const lastName = names.pop()

      return {
        firstName,
        lastName,
        email,
        phone: {
          formattedNumber: phone,
          countryCode: country.code
        }
      }
    },
    refreshPeresonalInfo () {
      const {
        firstName,
        lastName = '',
        phone,
        email
      } = this.getUserInfo()

      this.firstName = firstName
      this.lastName = lastName
      this.phone = phone
      this.email = email
      this.avatarTempSource = ''
      this.changePersonalDataError = ''
      this.avatar = ''
      this.$validator.errors.remove('phone')
      this.$validator.errors.remove('avatar')

    },
    async resetPasswordFields () {
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.chanePasswordError = ''
      this.showNewAndConfirmPasswordStatus = false
      this.showCurrentPasswordStatus = false

      const fieldsToRemove = ['current password', 'new password', 'confirm password']

      setTimeout(() => {
        const errors = JSON.parse(JSON.stringify(this.$validator.errors.items))

        errors.forEach(({field}) => {
          if (fieldsToRemove.includes(field)) {
            this.$validator.errors.remove(field)
          }
        })
      }, 0)
    },
    async validateFields (fields) {
      const results = Promise.all(
        fields.map(field => this.$validator.validate(field))
      )
      return (await results).every(isValid => isValid)
    },
    async updateProfile () {
      try {
        const fieldsToValidate = ['first name']

        const result = await this.validateFields(fieldsToValidate)
        if (
          result &&
          !(
            this.errors.has('phone') || this.errors.has('avatar')
          )
        ) {
          if (this.avatar) {
            await this.$store.dispatch(
              'authentication/updateProfileWithAvatar',
              objectToFormData({
                name: `${this.firstName} ${this.lastName}`,
                phone: this.phone,
                image: this.avatar
              })
            )
          } else {
            await this.$store.dispatch('authentication/updateProfile', {
              name: `${this.firstName} ${this.lastName}`,
              phone: this.phone
            })
          }
          this.changePersonalData = false
          this.chanePersonalDataPopup = true
          this.changePersonalDataError = ''
        }

      } catch (error) {

        const invalidFields = error.response && error.response.data &&  error.response.data.errors

        if (invalidFields['phone']) {
          this.$validator.errors.add({
            field: 'phone',
            //spread error messages as lines
            msg: invalidFields['phone'].reduce((acc, val) => {
              return `${acc + val  }\n`
            }, '')
          })
          delete invalidFields.phone
        }

        this.changePersonalDataError = invalidFields[Object.keys(invalidFields)[0]] ? invalidFields[Object.keys(invalidFields)[0]][0] : ''

      }

    },
    phoneUpdated (event) {
      this.$validator.errors.remove('phone')
      this.phone = event

      if (event.isValid) {
        this.$validator.errors.remove('phone')
      } else if (event.phoneNumber) {
        this.$validator.errors.add({
          field: 'phone',
          msg: 'phone number is invalid'
        })
      } else {
        this.$validator.errors.add({
          field: 'phone',
          msg: 'The phone number field is required'
        })
      }
    },
    openFileUploader () {
      if (this.changePersonalData) {
        this.$refs.fileInput.click()
      }
    },
    validateAvatar (avatar) {
      let isValid = true

      // maximum size is 1 megabyte
      const avatarMaximumSizeInBytes = 1000000
      if (avatar.size > avatarMaximumSizeInBytes) {
        this.$validator.errors.add({
          field: 'avatar',
          msg: 'Maximum size exceeded'
        })
        isValid = false
      }

      const validTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!validTypes.includes(avatar.type)) {
        this.$validator.errors.add({
          field: 'avatar',
          msg: 'only support jpeg/jpg/png'
        })
        isValid = false
      }
      return isValid
    },
    exitPersonalDataPopup () {
      this.chanePersonalDataPopup = false
      window.location.reload()
    },
    async setAvatar (event) {
      this.$validator.errors.remove('avatar')

      const avatar = event.target.files[0]
      if (!this.validateAvatar(avatar)) {
        return
      }

      this.avatar = avatar

      const fileReader = new FileReader()

      fileReader.onload = () => {
        this.avatarTempSource = fileReader.result
      }

      const file = event.target.files[0]
      if (file instanceof File || file instanceof Blob) {
        fileReader.readAsDataURL(file)
      }
    },
    async updatePassword () {
      try {
        if (this.errors.has('confirm password')) {
          return
        }

        const fieldsToValidate = ['current password', 'new password', 'confirm password']

        const result = await this.validateFields(fieldsToValidate)
        if (result) {
          if (this.currentPassword === this.newPassword) {
            this.chanePasswordError = 'You can’t use your current password'

            return
          }
          await window.axios.patch('/users/password', {
            currentPassword: this.currentPassword,
            newPassword: this.newPassword
          })
          this.changePassword = false
          this.chanePasswordPopup = true
          this.chanePasswordError = ''
          await this.resetPasswordFields()
        }

      } catch (error) {

        const errorMessage = error.response && error.response.data && error.response.data.message
        if (errorMessage === 'current password is invalid.') {
          this.$validator.errors.add({
            field: 'current password',
            msg: 'The Password you entered is incorrect.'
          })
          return
        }
        this.chanePasswordError = errorMessage
      }
    }
  }
}
</script>

<style lang="scss">
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 30%;
}

.header {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;

  /* identical to box height */
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.show-password-icon {
  position: absolute;
  font-weight: 100;
  top: 20px;
  right: 2%;
  z-index: 1;
}

.labels {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

.titles {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.small-txt {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #999;
}

.fullname {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.btn-save {
  min-width: 121px;
  height: 42px;
  border-radius: 3px;
}

.btn-cancel {
  min-width: 121px;
  height: 42px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
}

.personal-save-button {
  background: #0092d7 !important;
}

.success-pop-up-img {
  width: 130px;
}

.success-button {
  width: 250px;
  height: 48px;
  border-radius: 3px;
  margin-top: 27px;
  background-color: #0092d7 !important;
}

.personal-success-pop-up {
  .vs-popup {
    // width:613px;
    padding-top: 37px;
    padding-bottom: 37px;
    border-radius: 16px;
  }
}

.pop-up-text {
  margin-top: 24px;
}

@media (max-width: 576px) {
  .pop-up-text {
    margin-top: 16px;
  }

  .success-button {
    margin-top: 16px;
    width: 240px;
    height: 40px;
  }
}
</style>

